"use client";
import videojs from "video.js";
import React, { useRef, useEffect } from "react";
import "video.js/dist/video-js.css";

const DDPlayer = ({ options, onReady }) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
      }));
    } else {
      const player = playerRef.current;

      if (options.poster) {
        const player = playerRef.current;
        player.poster(options.poster);
        player.src({ src: options.sources.src });
        //  player.currentTime(0);
        // var tracks = player.textTracks();
        // console.log(tracks);
      }
    }
  }, [options, onReady]);

  // si assicura il dismount del player quando il componente viene unmounted
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js vjs-16-9 vjs-default-skin" />
    </div>
  );
};

export default DDPlayer;
